import { MenuItem } from "@mui/material";
import { useState } from "react";

import { getTranslateByKey } from "@/main/services/utils";

import { useThreeDotsClaimContext } from "../contex";
import WrapperModalRequoteClaim from "@/main/screens/order/viewOrder/components/modalRequoteClaim/modalRequoteClaim";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";
import { Controls } from "@/main/services/constants/constantsControl";

interface IThreeDotsClaimRequoteProps {
	guidClaim: string;
	showRequoteButton: boolean;
	refreshClaim: () => void;
}
function ThreeDotsClaimRequote({ guidClaim, showRequoteButton, refreshClaim }: IThreeDotsClaimRequoteProps) {
	const { closeThreeDotsClaim, generateIdMenu } = useThreeDotsClaimContext();

	const [isOpenModal, setIsOpenModal] = useState(false);

	function handleClick() {
		setIsOpenModal(true);
		closeThreeDotsClaim();
	}

	const showRequoteButtonMenu = useKogControlElementId(Controls.IdRequoteOrdered) && showRequoteButton;

	if (!showRequoteButtonMenu) return null;

	return (
		<>
			{showRequoteButtonMenu && (
				<MenuItem id={generateIdMenu("requote")} onClick={handleClick}>
					{getTranslateByKey("information.requote")}
				</MenuItem>
			)}

			<WrapperModalRequoteClaim
				guidClaim={guidClaim}
				refreshClaim={refreshClaim}
				isOpenModal={isOpenModal}
				setIsOpenModal={setIsOpenModal}
				closeModal={() => setIsOpenModal(false)}
			/>
		</>
	);
}

export { ThreeDotsClaimRequote };
